/**
 * Analytics optionnel : définir REACT_APP_POSTHOG_KEY (et REACT_APP_POSTHOG_HOST si besoin).
 * La clé ne doit plus figurer dans index.html.
 */
export function initAnalytics() {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key || typeof window === "undefined") return;

  import("posthog-js").then(({ default: posthog }) => {
    posthog.init(key, {
      api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
      person_profiles: "identified_only",
      session_recording: {
        recordCrossOriginIframes: true,
        capturePerformance: false,
      },
    });
  });
}
